import { buildCrmCard } from 'crm-cards-sdk/buildCrmCard';
import TimelineContainer from '../crm_ui/profile/TimelineContainer';
const RecordTimelineCard = buildCrmCard({
  displayName: 'RecordTimelineCard',
  ContentComponent: TimelineContainer,
  useCardProps: () => {
    return {};
  }
});
export default RecordTimelineCard;